export const LOAD_MACHINES = "LOAD_MACHINES";
export const LOAD_MACHINES_SUCCESS = "LOAD_MACHINES_SUCCESS";
export const LOAD_MACHINES_ERROR = "LOAD_MACHINES_ERROR";
